export default "__VITE_ASSET__4068ce94__"